import firebase from 'firebase';
import { useEffect, useState } from 'react';
import api from './api';
import App from './App';
import SplashScreen from './components/others/SplashScreen';
import LandingPage from './pages/landing/LandingPage';
import fb from './services/firebase.service';
import services from './services/services';
import { useAuthState } from './state/auth';
import useErrors from './utils/hooks/errors.hooks';

const AuthSwitch: React.FC = () => {
  const handleErr = useErrors();

  const [loading, setLoading] = useState(true);
  const { resetAuth, setUser, auth } = useAuthState();

  useEffect(() => {
    const handleLogin = async (fbUser: firebase.User) => {
      try {
        const { token } = await fbUser.getIdTokenResult();
        const user = await api.request('auth/login', { token });
        setUser(user);
        setLoading(false);
      } catch (err) {
        handleErr(err);
        fb.auth().signOut();
        resetAuth();
        setLoading(false);
      }
    };

    const unsubscribe = fb.auth().onAuthStateChanged(async user => {
      if (user) {
        const methods = await fb.auth().fetchSignInMethodsForEmail(user.email!);
        if (methods.length === 1 && methods[0] === 'emailLink') {
          // user must set password
          window.location.replace('/signup');
          return;
        }

        await handleLogin(user);
        services.errors.setUser(user.uid, user.email);
      } else {
        resetAuth();
        setLoading(false);
        services.errors.resetUser();
      }
    });

    return () => {
      unsubscribe();
    };
  }, [handleErr, resetAuth, setUser]);

  if (loading) return <SplashScreen />;

  if (auth) return <App />;

  return <LandingPage />;
};

export default AuthSwitch;
